import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { ArrowLeft, Mail, Phone } from "lucide-react";
import { PasswordInput } from "./PasswordInput";

export function ForgotPasswordFlow({
  email,
  setEmail,
  resetMethod,
  setResetMethod,
  resetCode,
  setResetCode,
  newPassword,
  setNewPassword,
  resetStep,
  loading,
  onBack,
  onSendCode,
  onResetPassword
}) {
  return (
    <div className="space-y-6">
      <button 
        onClick={onBack}
        className="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
      >
        <ArrowLeft className="h-4 w-4 mr-2" /> Back to login
      </button>
      
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900">Reset Password</h2>
        <p className="text-gray-600 mt-2">Choose how you'd like to receive your reset code</p>
      </div>

      {resetStep === 1 && (
        <div className="space-y-4">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              className="pl-10"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            <Card 
              className={`cursor-pointer p-4 text-center transition-all ${resetMethod === 'whatsapp' ? 'ring-2 ring-blue-500' : 'hover:ring-1 hover:ring-gray-200'}`}
              onClick={() => setResetMethod('whatsapp')}
            >
              <Phone className="h-8 w-8 mx-auto mb-2 text-green-600" />
              <p className="font-medium">WhatsApp</p>
              <p className="text-xs text-gray-500">Code via WhatsApp</p>
            </Card>
            <Card 
              className={`cursor-pointer p-4 text-center transition-all ${resetMethod === 'email' ? 'ring-2 ring-blue-500' : 'hover:ring-1 hover:ring-gray-200'}`}
              onClick={() => setResetMethod('email')}
            >
              <Mail className="h-8 w-8 mx-auto mb-2 text-blue-600" />
              <p className="font-medium">Email</p>
              <p className="text-xs text-gray-500">Code via email</p>
            </Card>
          </div>
          
          <Button 
            onClick={onSendCode} 
            disabled={loading || !resetMethod}
            className="w-full bg-blue-600 hover:bg-blue-700"
          >
            {loading ? "Sending..." : "Send Reset Code"}
          </Button>
        </div>
      )}

      {resetStep === 2 && (
        <div className="space-y-4">
          <Input
            value={resetCode}
            onChange={(e) => setResetCode(e.target.value)}
            placeholder="Enter 6-digit code"
            className="text-center text-2xl tracking-widest"
            maxLength={6}
          />
          <PasswordInput
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="New password (min 8 characters)"
          />
          <Button 
            onClick={onResetPassword}
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700"
          >
            {loading ? "Resetting..." : "Reset Password"}
          </Button>
        </div>
      )}
    </div>
  );
}
